import React from 'react'

import { ConfigSettingsSidebar } from './ConfigSettingsSidebar'
import { type WorkspaceSettingsNavigateHandler } from './ConfigSettingsSidebarMenuItems'
import { ConfigSettingsTopBar } from './ConfigSettingsTopBar'
import { type ConfigSettingsProps } from './useConfigSettingsState'

type ConfigSettingsComponentProps = ConfigSettingsProps &
  (
    | { variant?: 'navbar'; onWorkspaceNavigate?: never }
    | {
        variant: 'sidebar'
        onWorkspaceNavigate: WorkspaceSettingsNavigateHandler
      }
  )

export const ConfigSettings: React.FC<ConfigSettingsComponentProps> = (
  props
) => {
  if (props.variant === 'sidebar') {
    return (
      <ConfigSettingsSidebar
        orgID={props.orgID}
        siteID={props.siteID}
        onWorkspaceNavigate={props.onWorkspaceNavigate}
      />
    )
  }

  return <ConfigSettingsTopBar orgID={props.orgID} siteID={props.siteID} />
}
